module.exports = __webpack_public_path__ + "static/media/attribute_melee_poison.bb861f30.png";